import { Methods, RegisterTransaction } from '~/api/finance/financeApiTypes';
import { HttpProblemError } from '~/api/provider/providerErrors';
import { AbonnementTypeEnum } from '~/graphql/books/factory/abonement/AbonnementFactoryTypes';
import {
  BuyAbonnementDocument,
  BuyAbonnementMutation,
} from '~/graphql/finance/GraphQLGeneratedCode';

export interface BuyAbonnementProps extends Omit<RegisterTransaction, 'saveBankCard' | 'methodPayment'> {
  abonnementType: AbonnementTypeEnum;
  emailForReceipt?: string;
  phone?: string;
  paymentMethod: Methods.bankCard | Methods.savedBankCard;
  bookId: number | null;
}

export interface BuyAbonnementResult {
  transaction: {
    id: number;
    confirmationUrl: string;
  }
}

export const financeGraphql = {
  async buyAbonnement(data: BuyAbonnementProps): Promise<BuyAbonnementResult> {
    const { financeGraphqlClient } = await import('~/feature/graphql/financeGraphqlClient');
    const response = await financeGraphqlClient().mutate<BuyAbonnementMutation>({
      mutation: BuyAbonnementDocument,
      variables: { input: data },
    });

    if (response.data.buyAbonnement.__typename === 'BuyAbonnementPayload') {
      return {
        transaction: {
          id: response.data.buyAbonnement.transaction.id,
          confirmationUrl: response.data.buyAbonnement.transaction.confirmationUrl,
        },
      };
    }

    if (response.data.buyAbonnement.__typename === 'ProblemType') {
      throw new HttpProblemError(response.data.buyAbonnement.message);
    }

    throw new Error('buyAbonnement mutation return unknown response');
  },
};
